
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorBase } from '@/components/a-interfaz/a-controlador';
    import { Novedad } from '@/__env/lib/Sistema/Novedades';
    import { Utiles } from '@/__env/pluggins/event-bus';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        public Cargando: boolean = false;
        public Abierto: boolean = false;

        async Iniciar()
        {
            this.Abierto = false;
            if ( this.$vuetify.breakpoint.xsOnly )
            {
                this.Pagina = 0;
            } else
            {
                this.Pagina = 1;
            }
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.Eventos.push(
                Utiles.onInstalar.subscribe( x =>
                {

                    if ( x )
                        this.Iniciar();
                    else
                        this.Abierto = false;
                } ) );
        }

        @Prop() public Controlador: ControladorBase;
        public get Usuario() { return this.Controlador.Usuario; };


        public Pagina: number = 1;
        Cerrar()
        {
            this.Abierto = false;
        }
    }
